import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { compact, sortByProp } from 'ramda-adjunct';
import { findIndex, flatten, pipe, pluck, propEq, uniq } from 'ramda';

export default class KineticJobAssembly extends Model {
  @attr('number') assemblySequence;
  @attr('number') requiredQuantity;
  @attr('date') updatedAt;
  @attr('date') createdAt;

  @belongsTo('kinetic-job', { inverse: 'assemblies', async: false }) job;
  @belongsTo('kinetic-part-rev', { inverse: null, async: false }) partRev;
  @hasMany('kinetic-assembly-operation', { inverse: 'assembly', async: false, embedded: true }) assemblyOperations;
  @hasMany('kinetic-assembly-material', { inverse: 'assembly', async: false, embedded: true }) materials;
  @hasMany('kinetic-issued-material', { inverse: 'assembly', async: false, cascadeDelete: true }) issuedMaterials;

  get part() {
    return this.partRev.part;
  }

  get assemblyDisplayLabel() {
    const { partNumber, partDescription } = this.part;
    return [this.assemblySequence, partNumber, partDescription].filter(str => str != null).join(' - ');
  }

  get allowedStations() {
    return pipe(
      pluck('stations'),
      flatten,
      compact,
      uniq,
    )(this.assemblyOperations ?? []);
  }

  get isReleased() {
    return this.job.isReleased;
  }

  getAssemblyOpAfter(assemblyOperation) {
    const sorted = sortByProp('order', this.assemblyOperations ?? []);
    const opIndex = findIndex(propEq(assemblyOperation.sequence, 'sequence'))(sorted);

    return sorted[opIndex + 1];
  }
}
